import { getDaysToDate, SoledadUtils } from '../../lib/helpers/utils';

export const DIAS_SALDO_PROXIMO_CADUCAR = 7;

export interface SaldoDisponible {
    idPromo: number;
    nombrePromo: string;
    caducidad: Date;
    saldo: number;
    proximoCaducar: boolean;
}

export class SaldoDisponibleHelper {
    static default(): SaldoDisponible {
        return {
            idPromo: null,
            nombrePromo: null,
            caducidad: null,
            saldo: null,
            proximoCaducar: false,
        };
    }

    static fromAPI(data): SaldoDisponible {
        const ret = SaldoDisponibleHelper.default();
        ret.idPromo = data.IDPROMO || null;
        ret.nombrePromo = data.DESCRIPCION || null;
        ret.caducidad = data.FECHAMAXIMACANJEO ? SoledadUtils.dateTimeParse(data.FECHAMAXIMACANJEO) : null;
        ret.saldo = data.SALDO || 0;
        ret.proximoCaducar = ret.caducidad ? getDaysToDate(ret.caducidad) <= DIAS_SALDO_PROXIMO_CADUCAR : false;
        return ret;
    }
}
